import React from "react";

const DeliveryTrackingContent = ({
  data,
  trackingNo = "",
  isLoading = false,
  isError = false,
  error = null,
}) => {
  if (isLoading) {
    return <p className="px-4 py-3">배송추적 정보를 조회 중입니다.</p>;
  }

  if (isError) {
    return (
      <p className="px-4 py-3 text-[#e80000]">
        배송추적 조회에 실패했습니다.
        {error?.message ? ` (${error.message})` : ""}
      </p>
    );
  }

  if (!data) {
    return <p className="px-4 py-3">조회된 배송추적 정보가 없습니다.</p>;
  }

  const normalizedTrackingData = data?.data || data?.result || data;

  if (normalizedTrackingData?.resultCode !== "OK") {
    return (
      <div className="px-4 py-3 text-[12px]">
        <p className="mb-2">
          <span className="font-bold">운송장번호</span> :{" "}
          {normalizedTrackingData?.wblNo || trackingNo || "-"}
        </p>
        <p className="text-[#e80000]">
          [{normalizedTrackingData?.resultCode || "-"}]{" "}
          {normalizedTrackingData?.resultMessage || "-"}
        </p>
      </div>
    );
  }

  const trackingList = Array.isArray(normalizedTrackingData?.wrkList)
    ? normalizedTrackingData.wrkList
    : [];

  return (
    <div className="text-[12px]">
      <div className="mb-3 rounded-[4px] bg-[#f5f5f5] p-3">
        <p>
          <span className="font-bold">송장번호</span> :{" "}
          {normalizedTrackingData?.wblNo || "-"}
        </p>
        <p>
          <span className="font-bold">주문번호</span> :{" "}
          {normalizedTrackingData?.custOrdNo || "-"}
        </p>
      </div>

      {trackingList.length === 0 ? (
        <p className="px-1 py-2">배송 이력 정보가 없습니다.</p>
      ) : (
        <div className="max-h-[24rem] overflow-auto border border-light-grey rounded-[4px]">
          <table className="w-full text-left text-[11px]">
            <thead className="bg-input-grey">
              <tr>
                <th className="border border-light-grey p-2">상태</th>
                <th className="border border-light-grey p-2">일시</th>
                <th className="border border-light-grey p-2">대리점</th>
                <th className="border border-light-grey p-2">담당자</th>
                <th className="border border-light-grey p-2">설명</th>
              </tr>
            </thead>
            <tbody>
              {trackingList.map((track, index) => (
                <tr key={`${track?.statusDate || "date"}-${index}`}>
                  <td className="border border-light-grey p-2">
                    {track?.statusName || "-"}
                  </td>
                  <td className="border border-light-grey p-2">
                    {track?.statusDate || "-"}
                  </td>
                  <td className="border border-light-grey p-2">
                    {track?.agencyName || "-"}
                    {track?.agencyTel ? ` (${track.agencyTel})` : ""}
                  </td>
                  <td className="border border-light-grey p-2">
                    {track?.workerName || "-"}
                    {track?.workerTel ? ` (${track.workerTel})` : ""}
                  </td>
                  <td className="border border-light-grey p-2">
                    {track?.description || "-"}
                    {track?.reasonMessage
                      ? ` / 사유: ${track.reasonMessage}`
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveryTrackingContent;
